import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b73b5150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "scroll-to-top" }

import { SCROLL_TO_TOP } from '@/events'
import { onBeforeMount, onBeforeUnmount, ref } from 'vue'
import eventBus from '@/di/eventBus'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheScrollToTop',
  setup(__props) {

const visible = ref<boolean>(false)

function scrollToTop (): void {
  window.scroll(0, 0)
}

function scrollListener (): void {
  visible.value = window.scrollY > 150
}

onBeforeMount((): void => {
  window.addEventListener('scroll', scrollListener)
  eventBus.$on(SCROLL_TO_TOP, scrollToTop)
})

onBeforeUnmount((): void => {
  window.removeEventListener('scroll', scrollListener)
  eventBus.$off(SCROLL_TO_TOP, scrollToTop)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("button", {
      class: "btn btn-secondary",
      onClick: scrollToTop
    }, " Scroll up ", 512), [
      [_vShow, visible.value]
    ])
  ]))
}
}

})